/**
 * Shared grid constants used by BackgroundPatternCanvas, NumberFrames, and all token helpers.
 * Changing GRID_SIZE here updates the background grid AND the number frame cell size globally.
 */
export var GRID_SIZE = 55;
/** NumberFrames cell size — kept in sync with the background grid */
export var NF_CELL_SIZE = GRID_SIZE;
